export default {
    getUsersFilter:state => state.filter,
    getUsersList:state => state.list,
    getUsersResult:state => state.result,
    getUsersMultipleSelection: state => state.multiSelect,

}